import type { PalletStatus, SensorStatus } from '../types/domain'
import { palletStatusLabel, sensorStatusLabel } from './format'

export function StatusBadge({ status }: { status: PalletStatus | SensorStatus }) {
  const label = status in sensorStatusLabel
    ? sensorStatusLabel[status as SensorStatus]
    : palletStatusLabel[status as PalletStatus]
  return <span className={`status status-${status.toLowerCase().replaceAll('_', '-')}`}>{label}</span>
}

